import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { TableScreenWithoutUpdate } from '../../blocks/table_block';
import Fetcher from '../../common/communicate';
import { PROJECT_PREFIX } from '../../const';
import PageFrame from '../../layouts/PageFrame';
import NewEntityButton from '../NewEntityButton';

const API_ENDPOINT = 'v2/media.vkplay.ru/settings/redirects/';

export default class CanonicalList extends React.Component {
    constructor(props) {
        super(props);
        this.refreshState = this.refreshState.bind(this);
        this.removeItemHandler = this.removeItemHandler.bind(this);
        this.state = {
            results: [],
            previous: 'none',
            next: 'none',
            total_pages: 0,
            current_page: 1,
        };
        this.API_ENDPOINT_QS = '';
    }

    refreshState() {
        this.setState({ results: [] });
    }

    removeItemHandler(event) {
        Fetcher(`v2/media.vkplay.ru/settings/redirects/${event.currentTarget.id}/`, 'DELETE', this.refreshState);
    }

    columns = [{
        Header: 'Старый тип',
        accessor: 'alias_old',
        maxWidth: 170,
    }, {
        Header: 'Новый тип',
        accessor: 'alias_new',
        maxWidth: 170,
    }, {
        Header: 'Старый slug',
        accessor: 'slug_old',
    }, {
        Header: 'Новый slug',
        accessor: 'slug_new',
    }, {
        Header: '',
        accessor: 'id',
        maxWidth: 50,
        Cell: (row) => (
            <div>
                <Link to={`${PROJECT_PREFIX}/canonical/${row.value}/edit`}>
                    <FontAwesomeIcon icon="pencil-alt" />
                </Link>
                <Button size="sm" variant="link" id={row.value} onClick={this.removeItemHandler}>
                    <FontAwesomeIcon id={row.value} icon="trash" />
                </Button>

            </div>
        ),
    },

    ];

    render() {
        return (
            <PageFrame type="canonical">
                <div className="container-fluid">
                    <Row className="mb-2">
                        <Col md={12}>
                            <NewEntityButton to="/canonical/new" />
                        </Col>
                    </Row>
                    <TableScreenWithoutUpdate
                        columns={this.columns}
                        endpoint={API_ENDPOINT + this.API_ENDPOINT_QS}
                        data={this.state}
                    />
                </div>
            </PageFrame>
        );
    }
}
